import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { makeStyles } from '@material-ui/core/styles';

const blockStyles = makeStyles(theme => ({
  root: {
    position: "relative"
  },
  thumb: {
    opacity: "1",
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    margin: "auto"
  },
  image: {
    position: "relative",
    zIndex: "1",
    transition: "opacity .7s ease",
    opacity: "0",
  }
}));

const ImageSmooth = props => {
  const classes = blockStyles();
  const { src, width, height, thumbSrc, imageClassName, thumbClassName, wrapperClassName } = props;

  const [imageIsReady, setImageIsReady] = useState(false);
  const [opacity, setOpacity] = useState(false);

  useEffect(() => {
    let img = new Image();
    img.src = src;

    img.onload = () => {
      setImageIsReady(true);
    };
  }, []);

  useEffect(() => {
    if(imageIsReady) {
      setTimeout(() => {
        setOpacity(true)
      }, 0);
    }
  }, [imageIsReady]);

  return (
    <div className = { clsx(classes.root, wrapperClassName) }>
      <img src = { thumbSrc }
           alt = 'thumbnail'
           className = { clsx(classes.thumb, thumbClassName) } />
      { imageIsReady && 
        <img src = { src } width = { width } height = { height }
        alt = 'top picture'
        className = { clsx(classes.image, imageClassName) } 
        style = {{ 
          opacity: opacity ? "1" : "0"
        }}/> }
    </div>
  )
}

export default ImageSmooth